export const COMMON = {
    MAX_NUMBER_VALUE: 999999999999999,
    EMPTY: 'ー',
};

export const MASTER_CATEGORY_LIST = {
    ROOM_LAYOUT_DIV: '0010000010',
    CLASSIFICATION_BATH_AND_TOILET: '0010000020',
    INDOOR_LAUNDRY_AREA_CLASSIFICATION: '0010000030',
    STATUS_CLASSIFICATION: '0010000040',
    STRUCTURE_CODE : '0010000460',
    AUTO_LOCK_CLASSIFICATION: '0010000430',
    IS_ELEVATOR_CLASSIFICATION: '0010000440',
    MANAGEMENT_TYPE: '0010000400',
    WORKING_TYPE: '0010000410',
    LANDUSE: '0010000450',

    ADDRESSEE_DIV_CLASSIFICATION: '0000000220',
    FAMILY_RELATIONSHI_DIV_CLASSIFICATION: '0020000150',
    HOME_BUILDING_TYPE_CLASSIFICATION: '0020000180',
    HOME_POSSESSION_TYPE_CLASSIFICATION: '0020000190',
    DEAL_PURPOSE_TYPE_CLASSIFICATION: '0020000230',
    DEAL_PURPOSE_TYPE_1_CLASSIFICATION: '0000000230',

    USER_AGE_CLASSIFICATION: '0020000040',
    MARITAL_STATUS_CLASSIFICATION: '0020000050',
    OCCUPATION_CATEGORY_CLASSIFICATION: '0020000060',
    ANNUAL_INCONME_RANGE_CLASSIFICATION: '0020000070',
    HOUSE_TYPE_CLASSIFICATION: '0020000080',
    HOUSING_LOAN_EXISTS_CLASSIFICATION: '0020000090',
    INVESMENT_PROPERTY_EXISTS_CLASSIFICATION: '0020000100',
};

export const SIM_TYPE = {
    HISTORY : 10,
    BEFORE: 100,
    CONFIRM: 110
}
export const FILE_TYPE = {
    PDF: 'application/pdf',
    IMAGE: 'image/*',
}
export const TAX_RATE = {
    INCLUDE : 1.1
}

export const TODO_CLASS = {
    UNDER_ASSESSMENT: '00010030', // 査定中
    DONE_ASSESSMENT: '00010040', // 査定完了
}

export const DELIVERY_ADDRESS = {
    HOME : 10,// 自宅
    WORK : 20,// 勤務先
    COMPANY : 30,// 会社
    OTHER : 99,// その他
}

